import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/calendar-icon.svg'
import _imports_1 from '@/assets/gray-user.svg'
import _imports_2 from '@/assets/red-x-mark.svg'
import _imports_3 from '@/assets/accordion-check-icon.svg'
import _imports_4 from '@/assets/pencil-gray.svg'


const _hoisted_1 = { class: "w-full mr-[2px] flex flex-col md:flex-row items-start overflow-y-auto" }
const _hoisted_2 = { class: "flex flex-col md:flex-row items-start md:items-center justify-between mb-3 h-[44px]" }
const _hoisted_3 = { class: "flex items-center gap-[2px]" }
const _hoisted_4 = { class: "relative text-primary-text-color text-xl leading-[26px] tracking-[0.01rem] font-semibold" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex justify-between" }
const _hoisted_9 = { class: "w-4/5 text-lg leading-[20px] tracking-[0.01rem] text-primary-text-color font-semibold" }
const _hoisted_10 = { class: "flex w-1/5 items-center gap-3 text-right justify-end" }
const _hoisted_11 = { class: "flex items-center gap-4" }
const _hoisted_12 = { class: "flex items-center gap-1" }
const _hoisted_13 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_14 = { class: "flex items-center gap-1" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "flex gap-1 items-center" }
const _hoisted_17 = { class: "text-sm text-[#898790]" }
const _hoisted_18 = { class: "flex flex-col mt-3" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "flex justify-between" }
const _hoisted_21 = { class: "w-4/5 text-lg leading-[20px] tracking-[0.01rem] text-primary-text-color font-semibold" }
const _hoisted_22 = { class: "flex items-center gap-3 w-1/5 justify-end text-right" }
const _hoisted_23 = { class: "flex items-center gap-4" }
const _hoisted_24 = { class: "flex items-center gap-1" }
const _hoisted_25 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_26 = { class: "flex items-center gap-1" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = ["id"]
const _hoisted_29 = { class: "flex flex-col gap-3" }
const _hoisted_30 = {
  key: 0,
  class: "bg-[#E5E4E2] rounded-primary-radius"
}
const _hoisted_31 = { class: "flex p-3 pt-0 gap-3" }
const _hoisted_32 = { class: "p-3 bg-white rounded-primary-radius shadow-primary-box-shadow w-[300px]" }
const _hoisted_33 = { class: "text-xl leading-[32px] tracking-[0.01rem] pb-3 text-primary-text-color font-semibold" }
const _hoisted_34 = { class: "w-full list-none flex flex-col items-start gap-3" }
const _hoisted_35 = { class: "w-full flex items-center gap-2 justify-between border-b border-gray-100 pb-1" }
const _hoisted_36 = {
  key: 1,
  class: "flex flex-col gap-3"
}
const _hoisted_37 = {
  key: 2,
  class: "col-span-2"
}
const _hoisted_38 = {
  key: 3,
  class: "flex flex-col gap-3"
}
const _hoisted_39 = {
  key: 4,
  class: "flex flex-col gap-3"
}
const _hoisted_40 = {
  key: 5,
  class: "col-span-2 p-3 bg-[#E5E4E2] rounded-primary-radius flex flex-col gap-2"
}
const _hoisted_41 = { class: "w-full flex items-center justify-between" }
const _hoisted_42 = { class: "flex items-center gap-3" }
const _hoisted_43 = { class: "flex items-center gap-1" }
const _hoisted_44 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_45 = { class: "flex items-center gap-1" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "mt-4" }
const _hoisted_49 = { class: "text-base font-normal text-" }
const _hoisted_50 = { class: "p-3 rounded-primary-radius bg-[#e5ecf6] mt-2" }
const _hoisted_51 = { class: "text-base font-normal text-" }
const _hoisted_52 = {
  key: 6,
  class: "flex gap-1 bg-[#E5E4E2] rounded-primary-radius p-3"
}
const _hoisted_53 = { class: "w-full flex items-center justify-between" }
const _hoisted_54 = { class: "flex items-center gap-3" }
const _hoisted_55 = { class: "flex items-center gap-1" }
const _hoisted_56 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_57 = { class: "flex items-center gap-1" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "mt-4 flex gap-2" }
const _hoisted_61 = { class: "text-base font-normal grow" }
const _hoisted_62 = { class: "px-3 py-[1px] rounded-primary-radius bg-[#e5ecf6] mt-2 h-fit w-fit" }
const _hoisted_63 = { class: "text-base font-normal h-fit w-fit" }
const _hoisted_64 = {
  key: 7,
  class: "col-span-2 p-3 bg-[#E5E4E2] rounded-primary-radius flex flex-col gap-2"
}
const _hoisted_65 = { class: "w-full flex items-center justify-between" }
const _hoisted_66 = { class: "flex items-center gap-3" }
const _hoisted_67 = { class: "flex items-center gap-1" }
const _hoisted_68 = { class: "text-sm text-[#898790] foont-medium" }
const _hoisted_69 = { class: "flex items-center gap-1" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = ["onClick"]
const _hoisted_72 = { class: "mt-4" }
const _hoisted_73 = { class: "text-base font-normal text-" }
const _hoisted_74 = { class: "p-3 rounded-primary-radius bg-[#e5ecf6] mt-2" }
const _hoisted_75 = { class: "text-base font-normal text-" }
const _hoisted_76 = { class: "relative flex items-center justify-center" }
const _hoisted_77 = {
  key: 0,
  class: "w-full h-screen fixed top-0 right-0 bottom-0 left-0 z-[777] bg-black/25"
}
const _hoisted_78 = { key: 0 }

import CustomAccordion from "@/components/Re-usable/Phase/CustomAccordion.vue";
import { ref, onMounted } from "vue";
import TechnicalDetails from "@/components/Project/TechnicalDetails.vue";
import ProjectMap from "@/components/Project/ProjectMap.vue";
import AddImageModal from "@/components/Re-usable/AddImageModal.vue";
import { useRoute } from "vue-router";
import IssueModal from "@/components/Project/Appointment/Modal/IssueModal.vue";
import NoteModal from "@/components/Project/Appointment/Modal/NoteModal.vue";
import InputModal from "@/components/Re-usable/InputModal.vue";
import GroupInput from "@/components/Re-usable/Phase/GroupInput.vue";
import SlideImagesBlock from "@/components/Re-usable/Phase/SlideImagesBlock.vue";
import { watch } from "vue";
import { errorToast, successToast } from "@/utils/custom-toast";
import client from "@/utils/axios";
import SyncImageWidget from "@/components/PhaseDetails/SyncImageWidget.vue";
import QCModal from "@/components/PhaseDetails/QCModal.vue";
import RepeatableGroupInput from "@/components/Re-usable/Phase/RepeatableGroupInput.vue";
import RepeatableInput from "@/components/Re-usable/Phase/RepeatableInput.vue";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  phaseDetails: any;
  phaseId: number;
  projectId: string;
  batches: Array<any>;
  isAddImageModalOpen: boolean;
  isBaumappeOpen?: boolean;
};

type Emits = {
  (event: "refresh"): void;
  (event: "toggleIsAddImageModalOpen", isOpen: boolean): void;
  (event: "toggleBaumappe", isOpen: boolean): void;
};

export default /*@__PURE__*/_defineComponent({
  __name: 'QcView',
  props: {
    phaseDetails: {},
    phaseId: {},
    projectId: {},
    batches: {},
    isAddImageModalOpen: { type: Boolean },
    isBaumappeOpen: { type: Boolean }
  },
  emits: ["refresh", "toggleIsAddImageModalOpen", "toggleBaumappe"],
  setup(__props: any, { emit: __emit }) {

const intersectionOptions = {
  root: null,
  rootMargin: "0px",
  threshold: 0.1,
};
const { t } = useTranslate();
const observer = new IntersectionObserver((entries, _observer) => {
  entries.forEach((entry) => {
    // TODO: ability to mark on which step we are on
    if (entry.isIntersecting) {
      // extract ID from the entry.target.id
      // const id = `scroll-${entry.target.id}`;
      // // Update the URL with the ID
      // history.replaceState(null, "", `#${id}`);
      // router.replace({ hash: `#${id}` });
    }
  });
}, intersectionOptions);

onMounted(() => {
  const elements = document.querySelectorAll(".observe");
  elements.forEach((element) => {
    observer.observe(element);
  });
});

const props = __props;

const emits = __emit;
const route = useRoute();

/** Resolve display label for select/static_select. Handles missing options (e.g. from termin API) and supports both option.option and option.name. */
function getSelectDisplayLabel(input: any): string {
  if (input?.value == null || input?.value === "") return "";
  const val = input.value;
  const opts = input.options;
  if (!opts || !Array.isArray(opts)) return String(val);
  const byId = opts.find(
    (opt: any) =>
      Number(opt.id) === Number(val) || String(opt.id) === String(val)
  );
  if (byId) return String(byId.option ?? byId.name ?? val);
  const byText = opts.find(
    (opt: any) =>
      String(opt.option ?? "").toLowerCase() === String(val).toLowerCase() ||
      String(opt.name ?? "").toLowerCase() === String(val).toLowerCase()
  );
  if (byText) return String(byText.option ?? byText.name ?? val);
  return String(val);
}

const selectedIssue = ref<any>(null);
const selectedNote = ref(null);
const isIssueModalOpen = ref(false);
const isNoteModalOpen = ref(false);
const isInputModalOpen = ref(false);
const isLoading = ref(false);
const showDetails = ref(false);
const selectedInput = ref<any>(null);
const selectedStep = ref<any>(null);
const isQcModalOpen = ref(false);
const selectedInputGroupIndex = ref<any>(null);
const selectedInputIndex = ref<any>(null);

const selectedTermins = ref(
  props.phaseDetails.termins.map((item: any) => item.id)
);

const toggleModalHandler: any = (
  input: any,
  step: any,
  inputIndex?: number,
  groupIndex?: number
) => {
  selectedInput.value = input;
  selectedStep.value = step;
  isInputModalOpen.value = !isInputModalOpen.value;
  selectedInputGroupIndex.value = groupIndex;
  selectedInputIndex.value = inputIndex;
};
let scrollableContainer = ref<any>(null);
watch(
  () => route.hash, // Watch for the 'id' param change in the route
  () => {
    if (route.hash) {
      let hashId = route.hash.replace("#", "");
      const targetElement = document.getElementById(hashId);
      if (targetElement) {
        const topPosition = targetElement.offsetTop - 200;

        // Use scrollTo to scroll to the adjusted position
        scrollableContainer.value.scrollTo({
          top: topPosition,
          behavior: "smooth",
        });
      }
    }
  },
  { immediate: true } // Immediately run on component mount
);

const generateReport = async () => {
  isLoading.value = true;
  successToast("Your report is being generated, please wait.");
  const projectId = route.params.id;
  const phaseId = route.params.phaseId;
  try {
    const resp = await client.post(
      `/projects/${projectId}/phase/${phaseId}/generate-report`
    );

    if (resp && resp.status === 200) {
      successToast("Report successfully generated.");
    } else {
      errorToast("Something went wrong!");
    }
    isLoading.value = false;
  } catch (error) {
    errorToast("Something went wrong!");
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (selectedIssue.value && isIssueModalOpen.value)
      ? (_openBlock(), _createBlock(IssueModal, {
          key: 0,
          issue: selectedIssue.value,
          options: props.phaseDetails.issueTypes,
          "is-open": isIssueModalOpen.value,
          "issue-block-types": props.phaseDetails.issueBlockTypes,
          "just-view": true,
          "header-title": selectedIssue.value ? selectedIssue.value.title : '',
          onToggleModal: _cache[0] || (_cache[0] = ($event: any) => {
      isIssueModalOpen.value = false;
      selectedIssue.value = null;
    })
        }, null, 8, ["issue", "options", "is-open", "issue-block-types", "header-title"]))
      : _createCommentVNode("", true),
    (selectedNote.value && isNoteModalOpen.value)
      ? (_openBlock(), _createBlock(NoteModal, {
          key: 1,
          note: selectedNote.value,
          "is-open": isNoteModalOpen.value,
          "just-view": true,
          "header-title": "Note",
          onToggleModal: _cache[1] || (_cache[1] = ($event: any) => {
      isNoteModalOpen.value = false;
      selectedNote.value = null;
    })
        }, null, 8, ["note", "is-open"]))
      : _createCommentVNode("", true),
    (isInputModalOpen.value && selectedInput.value)
      ? (_openBlock(), _createBlock(InputModal, {
          key: 2,
          input: selectedInput.value,
          step: selectedStep.value,
          "is-open": isInputModalOpen.value,
          project: _unref(route).params.id,
          termins: props.phaseDetails.termins,
          phase: _unref(route).params.phaseId ? Number(_unref(route).params.phaseId) : -1,
          "group-index": selectedInputGroupIndex.value,
          "input-index": selectedInputIndex.value,
          onRefresh: _cache[2] || (_cache[2] = () => emits('refresh')),
          onToggleModal: _cache[3] || (_cache[3] = 
      () => {
        isInputModalOpen.value = false;
        selectedInput.value = null;
        selectedStep.value = null;
      }
    )
        }, null, 8, ["input", "step", "is-open", "project", "termins", "phase", "group-index", "input-index"]))
      : _createCommentVNode("", true),
    (__props.isAddImageModalOpen && selectedInput.value)
      ? (_openBlock(), _createBlock(AddImageModal, {
          key: 3,
          steps: __props.phaseDetails.steps,
          termins: __props.phaseDetails.termins,
          "is-open": __props.isAddImageModalOpen,
          project: _unref(route).params.id,
          input: selectedInput.value,
          step: selectedStep.value,
          "header-title": selectedInput.value ? selectedInput.value.name : '',
          phase: _unref(route).params.phaseId ? Number(_unref(route).params.phaseId) : -1,
          "group-index": selectedInputGroupIndex.value,
          "input-index": selectedInputIndex.value,
          onToggleModal: _cache[4] || (_cache[4] = ($event: any) => {
      selectedInput.value = null;
      selectedStep.value = null;
      selectedInputGroupIndex.value = null;
      selectedInputIndex.value = null;
      _ctx.$emit('toggleIsAddImageModalOpen', false);
    }),
          onRefresh: _cache[5] || (_cache[5] = () => emits('refresh'))
        }, null, 8, ["steps", "termins", "is-open", "project", "input", "step", "header-title", "phase", "group-index", "input-index"]))
      : _createCommentVNode("", true),
    _createVNode(QCModal, {
      "is-qc-modal-open": isQcModalOpen.value,
      onOnClose: _cache[6] || (_cache[6] = 
      () => {
        isQcModalOpen.value = false;
        emits('refresh');
      }
    ),
      projectId: __props.projectId,
      phaseId: __props.phaseId,
      "phase-details": __props.phaseDetails,
      onGenerateReport: generateReport
    }, null, 8, ["is-qc-modal-open", "projectId", "phaseId", "phase-details"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        ref_key: "scrollableContainer",
        ref: scrollableContainer,
        class: _normalizeClass(["h-full w-full overflow-y-auto px-[50px] relative", `${__props.isBaumappeOpen ? 'w-1/2' : 'w-full'}`])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col w-full sticky top-0 z-20 bg-[#f1f0ee] pb-2 pt-6", `${showDetails.value ? 'h-[340px]' : 'h-[144px]'}`])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(__props.phaseDetails.project.name), 1)
            ]),
            (__props.phaseDetails.areQcFormsActive)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (isQcModalOpen.value = true)),
                  class: "flex items-center gap-1 text-base text-white font-semibold leading-5 tracking-[0.01rem] p-3 bg-[#393840] rounded-primary-radius outline-none hover:bg-[#202022] duration-300"
                }, _toDisplayString(_unref(t)("phase.qc_complete")), 1))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  disabled: isLoading.value,
                  onClick: generateReport,
                  class: "flex items-center gap-2 text-sm text-white font-semibold leading-[17px] tracking-[0.01rem] py-[13.5px] px-2 bg-[#393840] rounded-primary-radius outline-none hover:bg-[#202022] duration-300"
                }, [
                  (_openBlock(), _createElementBlock("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 14 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    class: _normalizeClass(`${isLoading.value ? 'animate-spin' : ''}`)
                  }, [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("path", {
                      d: "M5.50024 11H1.75024V14.75M8.50024 5H12.2502V1.25M1.4375 5.75255C1.85801 4.71175 2.56207 3.80978 3.46966 3.14917C4.37724 2.48856 5.45289 2.09564 6.57256 2.01538C7.69223 1.93512 8.81129 2.17055 9.80382 2.69496C10.7963 3.21937 11.6212 4.0119 12.1858 4.98209M12.5634 10.2478C12.1429 11.2886 11.4388 12.1906 10.5312 12.8512C9.62367 13.5118 8.54912 13.9042 7.42944 13.9845C6.30977 14.0647 5.18979 13.8293 4.19727 13.3049C3.20474 12.7805 2.37936 11.9881 1.8147 11.0179",
                      stroke: "white",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)
                  ]))], 2)),
                  _createTextVNode(" " + _toDisplayString(_unref(t)("phase.generate_report")), 1)
                ], 8, _hoisted_5))
          ]),
          _createElementVNode("div", null, [
            _createVNode(TechnicalDetails, {
              "show-details": showDetails.value,
              project: __props.phaseDetails.project,
              onToggleDetails: _cache[8] || (_cache[8] = ($event: any) => (showDetails.value = !showDetails.value))
            }, null, 8, ["show-details", "project"])
          ])
        ], 2),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(CustomAccordion, {
            "step-id": Math.random(),
            "step-name": `${_unref(t)('phase.issues').value} (${
            __props.phaseDetails.issues.length
          })`,
            "sticky-height": 
            showDetails.value ? 'top-[332px] z-[18]' : 'top-[143px] z-[18]'
          
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.phaseDetails.issues, (issue) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: issue.id,
                  class: "mt-3 flex flex-col gap-3 p-3 w-full bg-white rounded-primary-radius cursor-pointer",
                  onClick: ($event: any) => {
              selectedIssue.value = issue;
              isIssueModalOpen.value = true;
            }
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(issue.title), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", null, _toDisplayString(issue.terminName), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[16] || (_cache[16] = _createElementVNode("img", {
                        class: "w-3 h-3 cursor-pointer",
                        src: _imports_0,
                        alt: "Calendar"
                      }, null, -1)),
                      _createElementVNode("p", _hoisted_13, _toDisplayString(issue.createdAt
                      ? new Date(issue.createdAt).toLocaleDateString("DE")
                      : ""), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _cache[17] || (_cache[17] = _createElementVNode("img", {
                        class: "w-3 h-3",
                        src: _imports_1,
                        alt: "User"
                      }, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(issue.workers, (worker, index) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: index,
                          class: "text-sm text-[#898790] foont-medium"
                        }, [
                          _createTextVNode(_toDisplayString(worker), 1),
                          (index < issue.workers.length - 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, ","))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[18] || (_cache[18] = _createElementVNode("svg", {
                        width: "12",
                        height: "13",
                        viewBox: "0 0 12 13",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M1.64551 6.1877L5.66718 2.16603C6.86316 0.970048 8.80226 0.970048 9.99824 2.16603C11.1942 3.36201 11.1941 5.30118 9.99809 6.49716L5.35771 11.1376C4.56039 11.9349 3.26789 11.9348 2.47057 11.1374C1.67325 10.3401 1.67306 9.04754 2.47038 8.25022L7.11077 3.60984C7.50943 3.21117 8.15613 3.21117 8.55479 3.60984C8.95345 4.0085 8.95317 4.6547 8.55451 5.05336L4.53284 9.07503",
                          stroke: "#A7A5AE",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(issue.attachments?.length), 1)
                    ])
                  ])
                ], 8, _hoisted_7))
              }), 128))
            ]),
            _: 1
          }, 8, ["step-id", "step-name", "sticky-height"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(CustomAccordion, {
            "step-id": Math.random(),
            "step-name": `${_unref(t)('phase.notes').value} (${
            __props.phaseDetails.notes.length
          })`,
            "sticky-height": 
            showDetails.value ? 'top-[332px] z-[18]' : 'top-[143px] z-[18]'
          
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.phaseDetails.notes, (note) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: note.id,
                  class: "mt-3 flex flex-col gap-3 p-3 w-full bg-white rounded-primary-radius cursor-pointer",
                  onClick: ($event: any) => {
              selectedNote.value = note;
              isNoteModalOpen.value = true;
            }
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("h3", _hoisted_21, _toDisplayString(note.title), 1),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("p", null, _toDisplayString(note.terminName), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _cache[19] || (_cache[19] = _createElementVNode("img", {
                        class: "w-3 h-3 cursor-pointer",
                        src: _imports_0,
                        alt: "Calendar"
                      }, null, -1)),
                      _createElementVNode("p", _hoisted_25, _toDisplayString(note.createdAt
                      ? new Date(note.createdAt).toLocaleDateString("DE")
                      : ""), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _cache[20] || (_cache[20] = _createElementVNode("img", {
                        class: "w-3 h-3",
                        src: _imports_1,
                        alt: "User"
                      }, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(note.workers, (worker, index) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: index,
                          class: "text-sm text-[#898790] foont-medium"
                        }, [
                          _createTextVNode(_toDisplayString(worker), 1),
                          (index < note.workers.length - 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, ","))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ], 8, _hoisted_19))
              }), 128))
            ]),
            _: 1
          }, 8, ["step-id", "step-name", "sticky-height"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.phaseDetails.steps, (step) => {
          return (_openBlock(), _createElementBlock("div", {
            key: step.id,
            class: "mt-4"
          }, [
            _createElementVNode("div", {
              id: 'step-' + step.id
            }, [
              _createVNode(CustomAccordion, {
                "step-id": step.id,
                "step-name": step?.name,
                class: "observe",
                "sticky-height": 
              showDetails.value ? 'top-[332px] z-[18]' : 'top-[143px] z-[18]'
            
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_29, [
                      (step.checklist.filter((item)=> item.type === 'document').length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("h2", {
                              class: _normalizeClass(["p-3 text-xl leading-[32px] tracking-[0.01rem] text-primary-text-color font-semibold bg-[#E5E4E2] opacity-1 sticky z-10 flex items-center", `${step ? 'pb-3' : 'pb-0'} ${
                      showDetails.value ? 'top-[449px]' : 'top-[209px]'
                    }`])
                            }, _toDisplayString(_unref(t)("phase.missing")), 3),
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("h3", _hoisted_33, _toDisplayString(_unref(t)("phase.reviewed_documentation")), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.checklist.filter((item)=>item.type === 'document'), (input) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: input.id,
                                      class: "my-3"
                                    }, [
                                      _createElementVNode("ul", _hoisted_34, [
                                        _createElementVNode("li", _hoisted_35, [
                                          _createElementVNode("p", {
                                            class: _normalizeClass(["relative text-sm sm:text-base text-primary-text-color font-normal leading-5 tracking-[0.01rem] cursor-pointer", input.value ? 'line-through' : ''])
                                          }, _toDisplayString(input.name), 3),
                                          _createElementVNode("img", {
                                            class: _normalizeClass([input.value ? 'hidden' : 'block', "cursor-pointer"]),
                                            src: _imports_2,
                                            alt: ""
                                          }, null, 2),
                                          _createElementVNode("img", {
                                            class: _normalizeClass(input.value ? 'block' : 'hidden'),
                                            src: _imports_3,
                                            alt: "Check icon"
                                          }, null, 2)
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (step.inputs.some((input) => input.type === 'group' && input.finishedInputs > 0))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.inputs.filter((input) => input.type === 'group' && input.finishedInputs > 0), (input) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: input.id,
                                class: "bg-[#E5E4E2] rounded-primary-radius flex flex-col gap-2 relative"
                              }, [
                                _createVNode(GroupInput, {
                                  showDetails: showDetails.value,
                                  selectedTermins: selectedTermins.value,
                                  step: step,
                                  input: input,
                                  "child-inputs": step.inputs.filter((item)=> item.parentId === input.id),
                                  project: _unref(route).params.id,
                                  "phase-details": __props.phaseDetails,
                                  "header-class": `${
                        showDetails.value
                          ? 'top-[383px] z-[15]'
                          : 'top-[183px] z-[15]'
                      }`,
                                  "phase-status": "qc",
                                  phase: 
                        _unref(route).params.phaseId ? Number(_unref(route).params.phaseId) : -1
                      ,
                                  onRefresh: _cache[9] || (_cache[9] = () => emits('refresh'))
                                }, null, 8, ["showDetails", "selectedTermins", "step", "input", "child-inputs", "project", "phase-details", "header-class", "phase"])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (step.inputs.some((input) => input.type === 'image' && input.parentId === null && input.value?.length > 0))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.inputs.filter((input) => input.type === 'image' && input.parentId === null && input.value?.length > 0), (input) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: input.id,
                                class: "w-full p-3 bg-[#E5E4E2] rounded-primary-radius mb-3 relative"
                              }, [
                                _createVNode(SlideImagesBlock, {
                                  "is-group": false,
                                  showDetails: showDetails.value,
                                  selectedTermins: selectedTermins.value,
                                  "header-class": `${
                        showDetails.value
                          ? 'top-[381px] z-[15]'
                          : 'top-[192px] z-[15]'
                      } sticky `,
                                  onAddImageModalOpen: 
                        () => {
                          selectedInput.value = input;
                          selectedStep.value = step;
                          _ctx.$emit('toggleIsAddImageModalOpen', true);
                        }
                      ,
                                  input: input,
                                  step: step,
                                  steps: __props.phaseDetails.steps,
                                  refresh: () => _ctx.$emit('refresh')
                                }, null, 8, ["showDetails", "selectedTermins", "header-class", "onAddImageModalOpen", "input", "step", "steps", "refresh"])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (step.inputs.some((input) => input.type === 'repeatable_group' && input.finishedInputs > 0))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.inputs.filter((input) => input.type === 'repeatable_group' && input.finishedInputs > 0), (input) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: input.id,
                                class: ""
                              }, [
                                _createVNode(RepeatableGroupInput, {
                                  showDetails: showDetails.value,
                                  selectedTermins: selectedTermins.value,
                                  step: step,
                                  input: input,
                                  "child-inputs": step.inputs.filter((childInput) => input.id === childInput.parentId),
                                  project: _unref(route).params.id,
                                  phaseDetails: __props.phaseDetails,
                                  "phase-status": "qc",
                                  phase: 
                        _unref(route).params.phaseId ? Number(_unref(route).params.phaseId) : -1
                      ,
                                  onRefresh: _cache[10] || (_cache[10] = ($event: any) => (emits('refresh')))
                                }, null, 8, ["showDetails", "selectedTermins", "step", "input", "child-inputs", "project", "phaseDetails", "phase"])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (step.inputs.some((input) => !input.parentId && input.type === 'repeatable_input' && input.finishedInputs > 0))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.inputs.filter((input) => !input.parentId && input.type === 'repeatable_input' && input.finishedInputs > 0), (input) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: input.id,
                                class: ""
                              }, [
                                _createVNode(RepeatableInput, {
                                  "is-accordion": true,
                                  showDetails: showDetails.value,
                                  selectedTermins: selectedTermins.value,
                                  step: step,
                                  input: input,
                                  project: _unref(route).params.id,
                                  phaseDetails: __props.phaseDetails,
                                  phase: 
                        _unref(route).params.phaseId ? Number(_unref(route).params.phaseId) : -1
                      ,
                                  onRefresh: _cache[11] || (_cache[11] = () => emits('refresh'))
                                }, null, 8, ["showDetails", "selectedTermins", "step", "input", "project", "phaseDetails", "phase"])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (step.inputs.some((input) => input.type === 'text' && input.value && !input.parentId))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.inputs.filter((input) => input.type === 'text' && input.value && !input.parentId), (input) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: input.id,
                                class: "p-3 w-full bg-white rounded-primary-radius shadow-primary-box-shadow"
                              }, [
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, [
                                      _cache[21] || (_cache[21] = _createElementVNode("img", {
                                        class: "w-3 h-3 cursor-pointer",
                                        src: _imports_0,
                                        alt: "Calendar"
                                      }, null, -1)),
                                      _createElementVNode("p", _hoisted_44, _toDisplayString(input.createdAt
                                ? new Date(input.createdAt).toLocaleDateString(
                                    "de"
                                  )
                                : ""), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_45, [
                                      _cache[22] || (_cache[22] = _createElementVNode("img", {
                                        class: "w-3 h-3",
                                        src: _imports_1,
                                        alt: "User"
                                      }, null, -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(input.workers, (worker, index) => {
                                        return (_openBlock(), _createElementBlock("p", {
                                          key: index,
                                          class: "text-sm text-[#898790] foont-medium"
                                        }, [
                                          _createTextVNode(_toDisplayString(worker?.fullname), 1),
                                          (index < input.workers.length - 1)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_46, ","))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _createElementVNode("img", {
                                    onClick: ($event: any) => (toggleModalHandler(input, step)),
                                    class: "w-4 h-4 cursor-pointer",
                                    src: _imports_4,
                                    alt: "Pencil"
                                  }, null, 8, _hoisted_47)
                                ]),
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("p", _hoisted_49, _toDisplayString(input.name), 1),
                                  _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("p", _hoisted_51, _toDisplayString(input.value), 1)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (step.inputs.some((input) => input.type === 'number' && input.value && !input.parentId ))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.inputs.filter((input) => input.type === 'number' && input.value && !input.parentId), (input) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: input.id,
                                class: "p-3 w-1/3 bg-white rounded-primary-radius shadow-primary-box-shadow"
                              }, [
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                      _cache[23] || (_cache[23] = _createElementVNode("img", {
                                        class: "w-3 h-3 cursor-pointer",
                                        src: _imports_0,
                                        alt: "Calendar"
                                      }, null, -1)),
                                      _createElementVNode("p", _hoisted_56, _toDisplayString(input.createdAt
                                ? new Date(input.createdAt).toLocaleDateString(
                                    "de"
                                  )
                                : ""), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_57, [
                                      _cache[24] || (_cache[24] = _createElementVNode("img", {
                                        class: "w-3 h-3",
                                        src: _imports_1,
                                        alt: "User"
                                      }, null, -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(input.workers, (worker, index) => {
                                        return (_openBlock(), _createElementBlock("p", {
                                          key: index,
                                          class: "text-sm text-[#898790] foont-medium"
                                        }, [
                                          _createTextVNode(_toDisplayString(worker.fullname), 1),
                                          (index < input.workers.length - 1)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_58, ","))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _createElementVNode("img", {
                                    onClick: ($event: any) => (toggleModalHandler(input, step)),
                                    class: "w-4 h-4 cursor-pointer",
                                    src: _imports_4,
                                    alt: "Pencil"
                                  }, null, 8, _hoisted_59)
                                ]),
                                _createElementVNode("div", _hoisted_60, [
                                  _createElementVNode("p", _hoisted_61, _toDisplayString(input.name), 1),
                                  _createElementVNode("div", _hoisted_62, [
                                    _createElementVNode("p", _hoisted_63, _toDisplayString(input.value), 1)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (step.inputs.some((input) => (input.type === 'select' || input.type === 'static_select') && input.value && !input.parentId ))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(step.inputs.filter((input) => (input.type === 'select' || input.type === 'static_select') && input.value && !input.parentId), (input) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: input.id,
                                class: "p-3 w-full bg-white rounded-primary-radius shadow-primary-box-shadow"
                              }, [
                                _createElementVNode("div", _hoisted_65, [
                                  _createElementVNode("div", _hoisted_66, [
                                    _createElementVNode("div", _hoisted_67, [
                                      _cache[25] || (_cache[25] = _createElementVNode("img", {
                                        class: "w-3 h-3 cursor-pointer",
                                        src: _imports_0,
                                        alt: "Calendar"
                                      }, null, -1)),
                                      _createElementVNode("p", _hoisted_68, _toDisplayString(input.createdAt
                                ? new Date(input.createdAt).toLocaleDateString(
                                    "de"
                                  )
                                : ""), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_69, [
                                      _cache[26] || (_cache[26] = _createElementVNode("img", {
                                        class: "w-3 h-3",
                                        src: _imports_1,
                                        alt: "User"
                                      }, null, -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(input.workers, (worker, index) => {
                                        return (_openBlock(), _createElementBlock("p", {
                                          key: index,
                                          class: "text-sm text-[#898790] foont-medium"
                                        }, [
                                          _createTextVNode(_toDisplayString(worker.fullname), 1),
                                          (index < input.workers.length - 1)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_70, ","))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ])
                                  ]),
                                  _createElementVNode("img", {
                                    onClick: ($event: any) => (toggleModalHandler(input, step)),
                                    class: "w-4 h-4 cursor-pointer",
                                    src: _imports_4,
                                    alt: "Pencil"
                                  }, null, 8, _hoisted_71)
                                ]),
                                _createElementVNode("div", _hoisted_72, [
                                  _createElementVNode("p", _hoisted_73, _toDisplayString(input.name), 1),
                                  _createElementVNode("div", _hoisted_74, [
                                    _createElementVNode("p", _hoisted_75, _toDisplayString(getSelectDisplayLabel(input)), 1)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["step-id", "step-name", "sticky-height"])
            ], 8, _hoisted_28)
          ]))
        }), 128))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-col ml-auto", `${__props.isBaumappeOpen ? 'w-1/2' : 'w-fit'}`])
      }, [
        _createElementVNode("div", _hoisted_76, [
          (__props.isAddImageModalOpen === true && !selectedInput.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                _createElementVNode("div", {
                  class: _normalizeClass(["absolute top-[102px] xl:top-[65px] z-[777]", 
              props.phaseDetails.project.baummape === null
                ? 'right-[24px]'
                : 'right-[24px] xl:right-[70px]'
            ])
                }, [
                  (__props.isAddImageModalOpen && !selectedInput.value)
                    ? (_openBlock(), _createBlock(AddImageModal, {
                        key: 0,
                        steps: __props.phaseDetails.steps,
                        termins: __props.phaseDetails.termins,
                        "is-open": __props.isAddImageModalOpen,
                        project: _unref(route).params.id,
                        "header-title": _unref(t)('phase.add_picture').value,
                        phase: _unref(route).params.phaseId ? Number(_unref(route).params.phaseId) : -1,
                        onToggleModal: _cache[12] || (_cache[12] = ($event: any) => {
                selectedInput.value = null;
                selectedStep.value = null;
                _ctx.$emit('toggleIsAddImageModalOpen', false);
              }),
                        onRefresh: _cache[13] || (_cache[13] = () => emits('refresh'))
                      }, null, 8, ["steps", "termins", "is-open", "project", "header-title", "phase"]))
                    : _createCommentVNode("", true)
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ]),
        (__props.isBaumappeOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
              _createVNode(ProjectMap, {
                "phase-details": props.phaseDetails,
                onToggleProjectMap: _cache[14] || (_cache[14] = () => _ctx.$emit('toggleBaumappe', false))
              }, null, 8, ["phase-details"])
            ]))
          : _createCommentVNode("", true)
      ], 2),
      (!__props.isBaumappeOpen)
        ? (_openBlock(), _createBlock(SyncImageWidget, {
            key: 0,
            workers: __props.phaseDetails.workers,
            batches: __props.batches
          }, null, 8, ["workers", "batches"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})